import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Accueil() {
  const navigate = useNavigate();
  const redirected = useRef(false);

  useEffect(() => {
    if (redirected.current) return;
    redirected.current = true;
    navigate('/inscription', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50 flex items-center justify-center">
      <div className="text-center">
        <img
          src="https://static.readdy.ai/image/82792080bea9235a3a5c58a151cce2b4/fff4bb4e89a9e983dddf5fffb9dae068.png"
          alt="SUCCESSLINK AGENCY"
          className="w-20 h-20 object-contain mx-auto mb-4"
        />
        <p className="text-gray-500 text-sm">Redirection en cours...</p>
      </div>
    </div>
  );
}
